// extracted by mini-css-extract-plugin
module.exports = {"anchor":"InvisibleAnchor_anchor__OqqU2","headerUp":"InvisibleAnchor_headerUp__wRbCZ"};